module.exports = __webpack_public_path__ + "img/bottom_flower_002.2203c96e.svg";